<template>
    <sidebar v-model="sidebarStatus"
        :enable="enableSidebar"
    >
        <!-- sidebar 内容部分 -->
        <div
            class="app-sidebar-content">
            <!-- 头部 -->
            <div v-if="title" class="app-sidebar-title" @click.stop="closeAndGo('/')">
                <span class="app-sidebar-title-left-icon">
                    <img v-if="title.imageLeft" :src="title.imageLeft" :alt="title.altLeft"></img>
                    <icon v-else-if="title.svgLeft" :name="title.svgLeft"></icon>
                    <v-icon dark v-else-if="title.iconLeft">{{ title.iconLeft }}</v-icon>
                </span>
                <span>{{ title.text }}</span>
                <slot name="logo" class="app-sidebar-title-right-logo">
                    <span class="app-sidebar-title-right-logo">
                        <img v-if="title.imageRight" :src="title.imageRight" :alt="title.altRight"></img>
                        <icon v-else-if="title.svgRight" :name="title.svgRight"></icon>
                        <v-icon v-else-if="title.iconRight">{{ title.iconRight }}</v-icon>
                    </span>
                </slot>
            </div>

            <!-- 用户信息 -->
            <div v-if="user" class="app-sidebar-user">
                 <div class="user-avatar">
                    <v-icon light class="user-avatar-icon">face</v-icon>
                 </div>
                 <div class="user-info">
                     <div class="user-name"><v-icon>person</v-icon>{{user.name}}</div>
                     <div class="user-location"><v-icon>room</v-icon>{{user.location}}</div>
                     <div class="user-email"><v-icon>email</v-icon>{{user.email}}</div>
                 </div>
            </div>
            
            <!-- 导航列表分区块 -->
            <div v-if="blocks" class="app-sidebar-blocks">
                <v-list>
                  <v-list-group v-for="(item, index) in blocks" :value="item.active" v-bind:key="item.title">
                    <v-list-tile slot="item">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon>keyboard_arrow_down</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile v-for="subItem in item.lists" v-bind:key="subItem.label" @click="closeAndGo(subItem.link)">
                      <v-list-tile-content>
                        <v-list-tile-title :class="{'active': fullPath === subItem.link}">{{ subItem.label }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list-group>
                </v-list>
            </div>
        </div>
    </sidebar>
</template>

<script>
import {mapState} from 'vuex';
import Sidebar from './Sidebar';

export default {
    components: {
        Sidebar
    },
    computed: {
        ...mapState('appShell/appSidebar', [
            'show',
            'title',
            'user',
            'blocks'
        ]),
        sidebarStatus: {
            get() {
                return this.show;
            },
            set(val) {
                if (val) {
                    this.$emit('show-sidebar');
                }
                else {
                    this.$emit('hide-sidebar');
                }
            }
        },
        enableSidebar() {
            return this.$store.state.appShell.appHeader.show
                && this.$store.state.appShell.appHeader.showMenu;
        }
    },
    methods: {
        close() {
            this.sidebarStatus = false;
        },
        closeAndGo(route) {
            this.$router.push(route);
            this.close();
        }
    },
    data () {
      return {
        items: [
          {
            action: 'local_activity',
            title: 'Attractions',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'restaurant',
            title: 'Dining',
            active: true,
            items: [
              { title: 'Breakfast & brunch' },
              { title: 'New American' },
              { title: 'Sushi' }
            ]
          },
          {
            action: 'school',
            title: 'Education',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'directions_run',
            title: 'Family',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'healing',
            title: 'Health',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'content_cut',
            title: 'Office',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'local_offer',
            title: 'Promotions',
            items: [
              { title: 'List Item' }
            ]
          }
        ]
      }
    },
    watch: {
        '$route': function(route) {
            this.fullPath = route.path
        }
    },
    beforeMount() {
        this.fullPath = this.$route.path.split('/').slice(0, 3).join('/')
    }
};
</script>

<style lang="stylus">
    @import '~@/assets/styles/variables';
    @import '~vuetify/src/stylus/settings/_colors';

    $theme := {
        primary: #14a1e3
        accent: $blue.accent-2
        secondary: $grey.darken-3
        info: $blue.base
        warning: $amber.base
        error: $red.accent-2
        success: $green.base
    }

    $material-custom := {
        bg-color: #fff
        fg-color: #000
        text-color: #000
        primary-text-percent: 0.87
        secondary-text-percent: 0.54
        disabledORhints-text-percent: 0.38
        divider-percent: 0.12
        active-icon-percent: 0.54
        inactive-icon-percent: 0.38
    }
    $material-theme := $material-custom

// 左侧触发滑动宽度
$swipe-width = 20px

ul,li
    padding 0
    margin 0
    list-style none
a
    text-decoration none
    color #333
.list__tile
    font-size 14px!important
    .list__tile__title.active
        color blue
.app-sidebar-content
    &.app-sidebar-content-right
        box-shadow -3px 0 8px 1px rgba(0, 0, 0, 0.4)

        &.app-sidebar-title,
        &.app-sidebar-blocks
            text-align right

    .app-sidebar-title-left-icon,
    .app-sidebar-block-left-icon
        display inline-block
        width ($app-sidebar-left-icon-size + 10)px
        height 100%

        img
            vertical-align middle
            width ($app-sidebar-left-icon-size)px
            height ($app-sidebar-left-icon-size)px
        svg
            position relative
            left 0
            top 0
            transform none
            vertical-align middle
            height ($app-sidebar-left-icon-size)px
            width ($app-sidebar-left-icon-size)px

        .material-icons
            font-size ($app-sidebar-left-icon-size)px

    .app-sidebar-block-text
        display inline-block
        height 100%
        vertical-align middle

    .app-sidebar-title-right-logo,
    .app-sidebar-block-right-logo
        float right

        img
            width 20px
            height 20px
            margin-right 10px


    .app-sidebar-title
        color #fff
        padding 0 10px
        font-size 16px
        font-weight bold
        height $app-sidebar-title-height
        line-height $app-sidebar-title-height
        background: $theme.primary
        text-align left

    .app-sidebar-user
        padding 0 10px
        font-size 16px
        .user-avatar
            margin 30px auto 0 auto
            height 100px
            width 100px
            i
                font-size 100px
                color #666
        .user-info
            padding 20px 0
            text-align center
            border-bottom 1px solid #e0e0e0
            >div
                margin 5px 0
                i
                    font-size 18px
                    margin-right 5px

    .app-sidebar-blocks
        text-align left
        color #333
        .list
            padding 0
            .list--group .list__tile
                padding-left 35px    

</style>



// WEBPACK FOOTER //
// AppSidebar.vue?bb6783a6